import { useRegistration } from '@/context/RegistrationContext';
import { redirect } from '@/navigation';
import { useWregAppLink } from '@/components/webreg/useWregAppLink';
import { WregIntake } from '@/components/webreg/screens/WregIntake';
import { WregScreener } from '@/components/webreg/screens/WregScreener';
import { WregTracks } from '@/components/webreg/screens/WregTracks';
import { WregAgreement } from '@/components/webreg/screens/WregAgreement';
import { WregSwitch } from '@/components/webreg/screens/WregSwitch';
import { WregLabs } from '@/components/webreg/screens/WregLabs';
import { WregMonitor } from '@/components/webreg/screens/WregMonitor';
import { WregAllSet } from '@/components/webreg/screens/WregAllSet';
import { useWregFlowActions } from '@/components/webreg/WregFlowProvider';
import { useWregDev } from '@/components/webreg/dev/WregDevContext';
import { wregShippingFromContext } from '@/components/webreg/wregFlowState';

const WregIntakeRoute = () => {
  const { form, intakeNotice, runIntake, afterIntake } = useWregFlowActions();
  return (
    <WregIntake
      notice={intakeNotice}
      initial={form}
      onSubmit={runIntake}
      onSubmitted={afterIntake}
    />
  );
};

const WregScreenerRoute = () => {
  const { onScreenerContinue, onScreenerIneligible } = useWregFlowActions();
  return <WregScreener onContinue={onScreenerContinue} onIneligible={onScreenerIneligible} />;
};

const WregTracksRoute = () => {
  const { elig, tracks, tracksGate, onTracksContinue, onTracksNoCondition } = useWregFlowActions();
  const { disclosure } = useWregDev();
  return (
    <WregTracks
      offered={elig.tracks}
      blocked={elig.blocked}
      gate={tracksGate}
      disclosure={disclosure}
      initial={tracks}
      onContinue={onTracksContinue}
      onNoCondition={onTracksNoCondition}
    />
  );
};

const WregAgreementRoute = () => {
  const { runAlign, afterAlign, onDecline } = useWregFlowActions();
  return <WregAgreement onAccept={runAlign} onAccepted={afterAlign} onDecline={onDecline} />;
};

const WregSwitchRoute = () => {
  const { tracks, onSwitchAttest, onDecline } = useWregFlowActions();
  return <WregSwitch tracks={tracks} onSwitch={onSwitchAttest} onDecline={onDecline} />;
};

const WregLabsRoute = () => {
  const { registrationData } = useRegistration();
  const { onLabsYes, onLabsNo } = useWregFlowActions();
  return (
    <WregLabs initial={registrationData.labsCompleted} onYes={onLabsYes} onNo={onLabsNo} />
  );
};

const WregMonitorRoute = () => {
  const { registrationData } = useRegistration();
  const { saveShipping, onShippingContinued } = useWregFlowActions();
  return (
    <WregMonitor
      initial={wregShippingFromContext(registrationData)}
      onContinue={saveShipping}
      onContinued={onShippingContinued}
    />
  );
};

const WregAllSetRoute = () => {
  const getAppLink = useWregAppLink();
  return <WregAllSet onEnter={() => redirect(getAppLink())} />;
};

export {
  WregAgreementRoute,
  WregAllSetRoute,
  WregIntakeRoute,
  WregLabsRoute,
  WregMonitorRoute,
  WregScreenerRoute,
  WregSwitchRoute,
  WregTracksRoute,
};
